module.exports = __webpack_public_path__ + "static/media/施工後.7bb08ca1.jpg";